var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUploadIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 48,
    viewBox: "0 0 49 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.5 32L24.5 24L16.5 32",
    stroke: "black",
    strokeOpacity: 0.4,
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5 24V42",
    stroke: "black",
    strokeOpacity: 0.4,
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M41.2789 36.779C43.2296 35.7155 44.7706 34.0328 45.6587 31.9962C46.5468 29.9597 46.7314 27.6855 46.1834 25.5324C45.6353 23.3793 44.3859 21.47 42.6323 20.1059C40.8786 18.7418 38.7207 18.0005 36.4989 17.999H33.9789C33.3736 15.6575 32.2453 13.4837 30.6788 11.641C29.1124 9.79829 27.1486 8.33469 24.9351 7.36021C22.7216 6.38572 20.316 5.92571 17.8992 6.01476C15.4823 6.1038 13.1171 6.73959 10.9813 7.87432C8.84552 9.00905 6.99477 10.6132 5.56819 12.5662C4.14161 14.5191 3.17632 16.7701 2.7449 19.1498C2.31348 21.5295 2.42715 23.9761 3.07737 26.3055C3.72759 28.635 4.89743 30.7867 6.49894 32.599",
    stroke: "black",
    strokeOpacity: 0.4,
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M32.5 32L24.5 24L16.5 32",
    stroke: "black",
    strokeOpacity: 0.4,
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadIcon);
export default __webpack_public_path__ + "static/media/uploadIcon.2df18018e4ae693473dd22804da171a2.svg";
export { ForwardRef as ReactComponent };